import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export type AppName = "liff" | "trial-mode" | "zippy-and-me";

const CLOUD_ROLE_NAME = "digital-experience";

const CONNECTION_STRING =
  "InstrumentationKey=ba907cff-a48c-400a-b0f1-0d03c4964505;IngestionEndpoint=https://southeastasia-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southeastasia.livediagnostics.monitor.azure.com/";

export function getAppName(
  pathname: string = window.location.pathname,
): AppName {
  if (pathname.startsWith("/line/")) return "liff";
  if (pathname.startsWith("/zippy-and-me/")) return "zippy-and-me";
  return "trial-mode";
}

export function initAppInsights(): ApplicationInsights {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: CONNECTION_STRING,
      autoTrackPageVisitTime: true,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      enableAjaxErrorStatusText: true,
      correlationHeaderExcludedDomains: [
        "*doubleclick*",
        "*facebook*",
        "*google*",
      ],
    },
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((envelope) => {
    const tags = envelope.tags || (envelope.tags = {});
    tags["ai.cloud.role"] = CLOUD_ROLE_NAME;

    const baseData = envelope.baseData as
      { properties?: Record<string, unknown> } | undefined;

    if (baseData) {
      baseData.properties = {
        ...baseData.properties,
        appName: getAppName(),
      };
    }

    return true;
  });

  appInsights.trackPageView();

  return appInsights;
}
